import { useNavigate } from "react-router-dom";
import { PropsView } from "../Models/faq";

const infos = [
  {
    title: "O que é Freeflow?",
    text: "O sistema Free Flow em pedágios é uma tecnologia que permite que os veículos passem pelas praças de pedágio sem necessidade de parar. Ao invés de realizar uma parada para pagamento, o veículo é identificado automaticamente por meio de dispositivos como tags ou câmeras, e o valor da tarifa é cobrado de forma eletrônica."
  },
  {
    title: "O que é o Pedágio Digital?",
    text: "O Pedágio Digital é um site/app onde você consegue consultar e pagar as suas passagens em rodovias sob a concessão da CCR e Econoroeste."
  },
  {
    title: "Quais são os benefícios do Free Flow em pedágios?",
    text: "Maior Agilidade: O trânsito fica mais fluido, pois não há necessidade de parar nos pedágios. Redução de Congestionamentos: Como os veículos não param, a chance de congestionamentos nas praças de pedágio diminui significativamente."
  },
  {
    title: "Como faço para pagar as tarifas de Free Flow?",
    text: "Caso você tenha a TAG no seu veículo, a cobrança das tarifas são realizadas automaticamente na conta da TAG e você não precisa tomar nenhuma ação. Caso você não tenha TAG, é necessário você consultar suas passagens em portais das concessionárias ou no site/app do Pedágio Digital e realizar o pagamento."
  },
  {
    title: "Como funciona o Free Flow?",
    text: "O sistema funciona por meio de tecnologias de identificação automática, como as antenas para leitura das tags e câmeras de leitura de placas. Ao se aproximar os sensores localizados na pista leem os dados do veículo e o valor da tarifa é cobrado automaticamente, sem a necessidade de o motorista parar ou interagir com um atendente."
  },
  {
    title: "Onde o Free Flow está disponível?",
    text: "O sistema Free Flow está sendo implementado em várias rodovias e praças de pedágio no Brasil e no mundo. Ele pode ser encontrado em rodovias com cobrança eletrônica de pedágio, especialmente em regiões onde há uma grande quantidade de veículos e o objetivo é melhorar o fluxo de tráfego."
  },
  {
    title: "Como funciona o Free Flow para quem tem tag?",
    text: "O Free Flow para quem tem TAG funciona de maneira simples e eficiente. Com a TAG instalada no veículo, o motorista pode passar pelo Free Flow que a passagem será registrada no TAG como habitualmente acontece quando passa nas praças de pedágio comuns. Ter a TAG apresenta vantagens para o usuário do Free Flow porque além de ter a cobrança automática na TAG os usuários contam com DESCONTO sobre o valor da tarifa."
  },
  {
    title: "Em quais locais ficam os porticos Free Flow?",
    element: `
      Os pórticos do Free Flow estão localizados nas seguintes rodovias e 
      trechos:
      <style>
        .tabela {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          font-size:0.8rem;
        }
        .tabela thead {
          background-color: #f0f0f0;
        }
        .tabela th,
        .tabela td {
          padding: 6px;
          border: 1px solid #ccc;
          vertical-align: top;
          text-align: left;
        }
        .col1,
        .col2,
        .col3 {
          width: auto;
        }
        .col4 {
          width: 4ch;
          text-align: center;
          white-space: nowrap;
        }
        @media (max-width: 600px) {
          .tabela th,
          .tabela td {
            padding: 4px;
          }
        }
      </style>
      <table class="tabela">
        <thead>
          <tr>
            <th class="col1">CONCESSIONARIA</th>
            <th class="col2">LOCAL</th>
            <th class="col3">CIDADE</th>
            <th class="col4">UF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM414+900, NORTE,</td>
            <td class="col3">ITAGUAÍ</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM414+900, SUL,</td>
            <td class="col3">ITAGUAÍ</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM447+300, NORTE,</td>
            <td class="col3">MANGARATIBA</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM447+300, SUL,</td>
            <td class="col3">MANGARATIBA</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM538+500, NORTE,</td>
            <td class="col3">PARATY</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">CCR RIO-SP </td>
            <td class="col2">BR101, KM538+500, SUL,</td>
            <td class="col3">PARATY</td>
            <td class="col4">RJ</td>
          </tr>
          <tr>
            <td class="col1">ECONOROESTE</td>
            <td class="col2">SP333, KM178+935, LESTE,</td>
            <td class="col3">ITÁPOLIS</td>
            <td class="col4">SP</td>
          </tr>
          <tr>
            <td class="col1">ECONOROESTE</td>
            <td class="col2">SP333, KM179+115, OESTE,</td>
            <td class="col3">ITÁPOLIS</td>
            <td class="col4">SP</td>
          </tr>
          <tr>
            <td class="col1">ECONOROESTE</td>
            <td class="col2">SP333, KM109+700, LESTE,</td>
            <td class="col3">JABOTICABAL</td>
            <td class="col4">SP</td>
          </tr>
          <tr>
            <td class="col1">ECONOROESTE</td>
            <td class="col2">SP333, KM110+690, OESTE,</td>
            <td class="col3">JABOTICABAL</td>
            <td class="col4">SP</td>
          </tr>
        </tbody>
      </table>`
  },
  {
    title: "Passei por um pórtico que não está na relação. O que fazer?",
    text: "Neste caso será necessário que procure no site da respectiva concessionária instruções para pagamento de sua passagem."
  },
  {
    title: "Em quanto tempo aparece a cobrança de passagem no freeflow (para clientes sem tag)?",
    text: "A tarifa pode levar até 48 horas para aparecer no sistema. Se não encontrar sua passagem, tente novamente mais tarde. O pagamento deve ser feito em até 30 dias."
  },
  {
    title: "Qual o prazo para pagamento das passagens de Free Flow?",
    text: "O prazo para pagamento das passagens de Free Flow é de até 30 dias. Se o pagamento não for feito dentro do prazo estipulado, a cobrança da passagem pode ser acrescida de juros, multas adicionais e o nome do motorista pode ser incluído em cadastros de inadimplentes. Além disto há a emissão de multa por evasão de pedágio e registro de pontos na CNH do motorista."
  },
  {
    title: "Como eu recorro a passagens no freeflow que eu não reconheço?",
    text: "Se você não reconhece passagens registradas no sistema Free Flow, é possível recorrer a essas cobranças. O processo pode variar dependendo da concessionária ou órgão responsável pela rodovia, mas, de modo geral, o procedimento segue alguns passos padrão:\n1. Verifique os Detalhes da Passagem\nAntes de recorrer, consulte os detalhes da cobrança, como data, hora, local e o valor da tarifa.\n2. Para resolver passagens não reconhecidas acesse o site da concessionária."
  },
  {
    title: "Dúvidas sobre a multa do Free Flow?",
    text: "O não pagamento da tarifa em até 30 dias corridos da passagem está sujeito a multa de trânsito no valor de R$ 195,23 e 5 pontos na CNH (Artigo 209 do Código de Trânsito Brasileiro), além de encargos. A data da infração é referente ao vencimento do pagamento da passagem, ou seja, o trigésimo primeiro dia. No rodapé da notificação da multa encontram-se a data e hora da passagem pelo pórtico de cobrança. Vale lembrar que a multa não desobriga o pagamento da tarifa."
  },
  {
    title: "Qual é o prazo para pagar ou contestar a multa?",
    text: "Os prazos para pagamento e contestação da multa estão indicados na notificação que você recebeu e a contestação é feita diretamente ao orgão de transito que emitiu o domcumento. Lembre-se de que pagar a multa não isenta o pagamento do pedágio."
  },
  {
    title: "Existe desconto para usuários frequentes?",
    text: "O desconto de usuário frequente é feito exclusivamente para usuários que tem a TAG instalada no veículo, nos contratos de concessionárias que preveem este desconto"
  },
  {
    title: "Consultei o site e encontrei uma passagem que não reconheço. Posso contestar a passagem do Free Flow?",
    text: "Sim! Se você acha que a passagem foi gerada de forma equivocada, você pode contestar.\nPara recorrer, você pode acessar o site da concessionária responsável, onde encontrará o processo de contestação. Será necessário fornecer dados do veículo e informações sobre o erro."
  },
  {
    title: "O que acontece se o pagamento não for realizado?",
    text: "De acordo com o artigo 209-A do Código de Trânsito Brasileiro (CTB), não pagar a tarifa de pedágio é uma infração grave. Isso pode resultar em uma multa de R$ 195,23 e 5 pontos na CNH."
  },
  {
    title: "O que é evasão?",
    text: "Evasão de pedágio nada mais é do que o ato de transpor um pedágio ou pórtico Free Flow sem efetuar o pagamento.\nA evasão é caracterizada pela ação de um veículo que passa pelo pedágio sem o registro do pagamento da tarifa, para regularização, esta passagem deverá ser quitada."
  },
  {
    title: "O que acontece se meu veículo não for identificado corretamente?",
    text: "Se o sistema não conseguir identificar seu veículo automaticamente, você pode ser cobrado com base na sua placa por meio de fiscalização por câmeras ou receber uma notificação para regularizar a cobrança. É importante garantir que sua tag esteja funcionando corretamente e esteja bem posicionada no veículo para evitar problemas."
  },
  {
    title: "O que acontece se minha tag não tiver saldo suficiente?",
    text: "Entre em contato com a operadora da tag para regularizar a situação. Caso não pague, estará sujeito a multa por evasão de pedágio."
  },
  {
    title: "E se minha tag não for reconhecida no pedágio?",
    text: "Caso a passagem não seja cobrada automaticamente, você poderá pagar manualmente dentro de um prazo no site do Pedágio Digital. Se precisar de ajuda, entre em contato com a sua operadora de tag para mais informações."
  },
  {
    title: "A cancela da pista automática não abriu e ouvi um alerta. O que fazer?",
    text: "Siga viagem e consulte sua passagem no Pedágio Digital o quanto antes. A passagem será disponibilizada no Pedágio Digital até 48 horas. Se não encontrar, entre em contato com a concessionária."
  },
  {
    title: "Passei por uma pista automática sem tag. O que devo fazer?",
    text: "Cabines automáticas são exclusivas para veículos com tag. Caso não tenha, consulte sua passagem e efetue o pagamento no site do Pedágio Digital em até 24 horas."
  },
  {
    title: "Quais são os métodos de pagamento disponíveis para os veículos que não possuem tag?",
    text: "Você pode pagar em até 30 dias após a passagem, via Pix, cartão de crédito ou com a carteira no site do Pedágio Digital."
  },
  {
    title: "Quais os contatos das concessionárias que atuam no freeflow?",
    text: `CCR RioSP
            Site: www.rodovias.grupoccr.com.br/riosp
            Telefone e WhatsApp: (11) 2795-2238
            
            Caminhos das Serras Gaúchas
            Site: www.csg.com.br
            Telefone e WhatsApp: 0800 122 0240
            
            EPR Sul de Minas
            Site: www.eprsuldeminas.com.br
            Telefone e WhatsApp/chatbot: 0800 290 0459
            
            Econoroeste
            Site: www.econoroeste.com.br
            Telefone: 0800 326 3663
            
            Tamoios
            Site: www23.concessionariatamoios.com.br
            Telefone: (12) 3924 - 1197`
  },
  {
    title: "As câmeras dos pórticos multam por excesso de velocidade?",
    text: "As câmeras instaladas nos pórticos do sistema free flow têm o objetivo de permitir a identificação do veículo, de maneira de garantir a cobrança da tarifa. Os pórticos preveem radares para fiscalizar a velocidade dos veículos e garantirem que os mesmos cumpram a estabelecida na via. Recomendamos sempre respeitar os limites de velocidade."
  },
  {
    title: "O Free Flow cobra por quilômetro percorrido?",
    text: "O modelo de cobrança do Free Flow  varia conforme a rodovia e a regulamentação vigente. Em algumas rodovias, como a Via Dutra na Região Metropolitana de São Paulo, a tarifa é proporcional à distância percorrida, ou seja, por quilômetro rodado. Já em outras rodovias, a cobrança é feita por tarifa fixa ao passar pelos pórticos, independentemente da distância percorrida"
  },
  {
    title: "Como vai funcionar a bonificação da tarifa para veículos isentos no modelo Free Flow?",
    text: "Cada concessionária tem um processo específico para registrar veículos isentos. Consulte a concessionária responsável para saber como fazer o cadastro.\nA isenção é concedida para veículos que atendem aos critérios definidos pelo orgão regulador (ex.: ARTESP, ANTT)"
  },
  {
    title: 'Quais são as Concessionárias parceiras?',
    element: `
      <style>
        .tabela-completa {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.95rem;
        }
        .tabela-completa th, .tabela-completa td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: left;
        }
        .tabela-completa thead {
          background: #f0f0f0;
        }
      </style>
      <table class="tabela-completa">
        <thead>
          <tr>
            <th>CONCESSIONÁRIA</th>
            <th>CNPJ</th>
            <th>ENDEREÇO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>CCR S/A</td>
            <td>02.846.056/0003-59</td>
            <td>Avenida Professora Maria do Carmo Guimarães Pellegrini 200, Blocos A, B, C e D, Bairro Retiro, Jundiaí/SP, 13.209-500</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DO SISTEMA ANHANGUERA-BANDEIRANTES S/A</td>
            <td>02.451.848/0001-62</td>
            <td>Avenida Professora Maria do Carmo Guimarães Pellegrini, 200 - Vila Viotto, Jundiaí - SP, 13.209-500</td>
          </tr>
          <tr>
            <td>COMPANHIA DE RODOVIA SUL-MATOGROSSENSE S/A</td>
            <td>19.642.306/0001-70</td>
            <td>Avenida Zila Correa Machado, 5600 - Moreninha, Campo Grande - MS, 79.065-660</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DO SISTEMA RODOVIÁRIO RIO - SÃO PAULO S/A</td>
            <td>44.319.688/0001-42</td>
            <td>Rodovia Presidente Dutra, Santa Isabel - SP, 07.500-000</td>
          </tr>
          <tr>
            <td>RODOVIAS INTEGRADAS DO OESTE S/A</td>
            <td>03.497.792/0001-40</td>
            <td>Rodovia Antonio Romano Schincariol - Jardim Tokio, Tatuí - SP, 18.279-588</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DA RODOVIA DOS LAGOS S/A</td>
            <td>01.612.234/0001-52</td>
            <td>Rodovia RJ-124 Km 22,0, Rio Bonito - RJ, 28.800-000</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DO RODOANEL OESTE S/A</td>
            <td>09.387.725/0001-59</td>
            <td>Rodo Anel Mario Covas - Vila Municipal, Carapicuíba - SP, 06.328-175</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DE RODOVIAS DO OESTE DE SÃO PAULO – VIAOESTE S/A</td>
            <td>17.945.408/0001-50</td>
            <td>Rodovia Presidente Castelo Branco - Jardim Mutinga, Barueri - SP, 06.463-400</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA VIARIO S/A</td>
            <td>20.061.249/0001-00</td>
            <td>Rua Euzébio de Almeida, 2503 - Jardim Sulacap, Rio de Janeiro - RJ, 21.741-172</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA DAS RODOVIAS INTEGRADAS DO SUL S/A</td>
            <td>31.371.063/0001-84</td>
            <td>Avenida Parana, 2435 - Navegantes, Porto Alegre - RS, 90.220-170</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA CATARINENSE DE RODOVIAS S/A</td>
            <td>46.384.763/0001-06</td>
            <td>Rua Silvio Burigo, 555 - Oficinas, Tubarão - SC, 88.702-500</td>
          </tr>
          <tr>
            <td>RENOVIAS CONCESSIONÁRIA S/A</td>
            <td>02.417.464/0001-20</td>
            <td>Rodovia Govador Doutor Adhemar Pereira de Barros - Jardim Santa Rosa, Mogi Mirim - SP, 13.805-280</td>
          </tr>
          <tr>
            <td>CONCESSIONÁRIA ROTA SOROCABANA S.A.</td>
            <td>58.484.141/0001-07</td>
            <td>Av Chedid Jafet, 222, Bloco B Andar 4 Sala 11, Vila Olimpia, São Paulo</td>
          </tr>

           <tr>
            <td>CONCESSIONÁRIA DE RODOVIAS PRVIAS S.A.</td>
            <td>59.196.897/0001-13</td>
            <td>R. Senador Souza Naves, 771, Sala 02, Centro, Londrina, Paraná</td>
          </tr>
           <tr>
            <td>ECORODOVIAS CONCESSÕES E SERVIÇOS S.A.</td>
            <td>08.873.873/0001-10</td>
            <td>Rodovia dos Imigrantes, km 28,5, 1º e 2º andares São Bernardo do Campo/SP, CEP 09.845-000</td>
          </tr>
           <tr>
            <td>CONCESSIONÁRIA DE RODOVIAS NOROESTE PAULISTA S.A.</td>
            <td>49.314.049/0001-08</td>
            <td>Rua Marlene David dos Santos, 325 - Jardim Paraíso III, Matão - SP, CEP 15991-360</td>
          </tr>
           <tr>
            <td>CONCESSIONÁRIA ECOVIAS RAPOSO-CASTELO S.A.</td>
            <td>58.607.200/0001-97</td>
            <td>Avenida Tamboré, 267, 20º andar, Torre Norte - Tamboré, Barueri - SP, CEP 06460-000</td>
          </tr>
        </tbody>
      </table>
    `
  }
];

export default function useFaqPage(): PropsView {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const goToContact = () => navigate("/faq/contact");

  return {
    goBack,
    goToContact,
    infos,
  };
}
